import { navigateWindow } from '@/router/routerUtils';
import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import CartPreviewActions from './CartPreviewActions.vue';
import CartPreviewItem from './CartPreviewItem.vue';
export default Vue.extend({
    components: { CartPreviewItem, CartPreviewActions },
    computed: {
        ...mapGetters('cartModule', ['cartItemsNumber', 'cartItemsPrice']),
        ...mapState('cartModule', ['items']),
    },
    data() {
        return {
            isOpen: false,
            lastFocusedEl: null,
            hideTrigger: { type: Boolean, default: false },
        };
    },
    mounted() {
        // close on outside click is now handled by overlay; keep global Esc
        document.addEventListener('keydown', this.onKeydown);
        // --- dvh fallback: set and keep --cp-vh in sync with visible viewport
        this.setViewportVar();
        window.addEventListener('resize', this.setViewportVar, { passive: true });
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', this.setViewportVar, { passive: true });
            window.visualViewport.addEventListener('scroll', this.setViewportVar, { passive: true });
        }
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.onKeydown);
        this.unlockScroll();
        window.removeEventListener('resize', this.setViewportVar);
        if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', this.setViewportVar);
            window.visualViewport.removeEventListener('scroll', this.setViewportVar);
        }
    },
    methods: {
        goToCart() { navigateWindow('cart'); },
        goToCheckout() { navigateWindow('checkout'); },
        toggle(next) {
            const target = typeof next === 'boolean' ? next : !this.isOpen;
            if (target === this.isOpen)
                return;
            this.isOpen = target;
            if (this.isOpen) {
                // remember focus origin, lock scroll, focus drawer
                this.lastFocusedEl = document.activeElement || null;
                this.lockScroll();
                this.$nextTick(() => {
                    const el = this.$refs.drawer;
                    if (el)
                        el.focus({ preventScroll: true });
                });
            }
            else {
                this.unlockScroll();
                if (this.lastFocusedEl)
                    this.lastFocusedEl.focus({ preventScroll: true });
            }
        },
        onKeydown(e) {
            if (e.key === 'Escape' && this.isOpen)
                this.toggle(false);
        },
        lockScroll() {
            // simple body scroll lock
            const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = scrollBarWidth ? `${scrollBarWidth}px` : '';
            document.documentElement.classList.add('cart-open');
        },
        unlockScroll() {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
            document.documentElement.classList.remove('cart-open');
        },
        // --- keeps --cp-vh matching the visible viewport height (excludes browser toolbars)
        setViewportVar() {
            const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
            document.documentElement.style.setProperty('--cp-vh', `${vh * 0.01}px`);
        },
    },
});
